// components/TransferPage.js

import React, { useState, useCallback } from 'react';
import TransferTable from '../Transfers/TransferTable';
import { Card, Modal, Button, Nav } from 'react-bootstrap';
import AddPayForm from '../Forms/AddPayForm';
import { getPays } from '../../services/PayService';
import '../../css/TransferTable.css';



const TransfersPage = () => {
  const [showAddPayModal, setShowAddPayModal] = useState(false);
  const [loading, setLoading] = useState(true);
  // key state to force remount
  const [refreshKey, setRefreshKey] = useState(0);

  // Reference to the TransferTable's refresh function
  const [refreshTransferTable, setRefreshTransferTable] = useState(null);

  const handleAddPayClick = () => setShowAddPayModal(true);

  // Register the refresh function from TransferTable
  const registerRefreshFunction = useCallback((refreshFn) => {
    setRefreshTransferTable(() => refreshFn);
  }, []);

  const handlePayAdded = async () => {
    try {
      setLoading(true);
      setShowAddPayModal(false);

      // Increment the key to force a remount of TransferTable
      setRefreshKey(prevKey => prevKey + 1);

      // If we have a refresh function, call it
      if (refreshTransferTable) {
        await refreshTransferTable();
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-content transfers-page">
      <Card className="transfers-page-card">
        <Card.Header className="transfers-nav-header transfers-page-header">
          <div className="d-flex justify-content-between align-items-center">
            <Nav variant="tabs" activeKey="#transfers">
              <Nav.Item>
                <Nav.Link eventKey="#transfers" active>Transfers</Nav.Link>
              </Nav.Item>
            </Nav>
            <div>
              <Button
                size="sm"
                className="pay-add-btn"
                onClick={handleAddPayClick}
              >+ Pay</Button>
            </div>
          </div>
        </Card.Header>
        <Card.Body className="transfers-page-body">
          <div className="transfers-page-shadow-box">
            <TransferTable
              key={refreshKey}
              registerRefresh={registerRefreshFunction}
            />
          </div>
        </Card.Body>
      </Card>

      {/* Modal for Adding Pay opened by the '+ Pay' button */}
      <Modal
        show={showAddPayModal}
        onHide={() => setShowAddPayModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Pay</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddPayForm onSuccess={handlePayAdded} />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default TransfersPage;
